import { render, staticRenderFns } from "./ModalWelcomePlanTrial.vue?vue&type=template&id=6478a82a"
import script from "./ModalWelcomePlanTrial.vue?vue&type=script&lang=ts"
export * from "./ModalWelcomePlanTrial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports